/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useEffect, useState } from 'react';
import { selectClusterDropdownOptions, selectHasClusters } from '../data/clusters/slice';
import { createCluster, fetchClusters } from '../data/clusters/thunks';
import { MAX_CLUSTERS_LIMIT, TopicTypes } from '../data/topicEditor/constants';
import { useDispatch, useSelector } from '../store';
import { ClusterDropdown } from './ClusterDropdown';
import { selectSelectedClusterId } from '../data/topicEditor/slice';
import { SELECTED_CLUSTER_CHANGED } from '../data/actionTypes';
import { IsSupportingContentCheckbox } from './IsSupportingContentCheckbox';
import { SubtopicDropdown } from './SubtopicDropdown';
import { AttachButton } from './AttachButton';
import { CreateTopicDialog } from './CreateTopicDialog';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { createSubtopic } from '../data/topics/thunks';
import { ZeroState } from './ZeroState';
import { selectIsFetchingClusters } from '../data/loading/slice';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useTracker } from '../../../context/hooks';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DialogHeaderText = ({
  topicType
}) => {
  switch (topicType) {
    case TopicTypes.CLUSTER:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.createTopicModal.cluster.header"
      });
    case TopicTypes.SUBTOPIC:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.createTopicModal.subtopic.header"
      });
    default:
      {
        console.error('No header text translation found for this topic type:', topicType);
        return null;
      }
  }
};
const DialogMessageText = ({
  topicType
}) => {
  switch (topicType) {
    case TopicTypes.CLUSTER:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.createTopicModal.cluster.message"
      });
    case TopicTypes.SUBTOPIC:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.createTopicModal.subtopic.message"
      });
    default:
      {
        console.error('No message text translation found for this topic type:', topicType);
        return null;
      }
  }
};
const useCreateTopicDialog = ({
  selectedClusterId
}) => {
  const {
    track
  } = useTracker();
  const [openDialog, setOpenDialog] = useState(false);
  const [topicType, setTopicType] = useState(TopicTypes.CLUSTER);
  const dispatch = useDispatch();
  const handleOpenDialog = type => {
    setTopicType(type);
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleSaveDialog = ({
    phrase
  }) => {
    if (topicType === TopicTypes.CLUSTER) {
      dispatch(createCluster(phrase));
    } else if (topicType === TopicTypes.SUBTOPIC && selectedClusterId) {
      dispatch(createSubtopic(selectedClusterId, phrase));
    }
    track('clickedCreateTopic');
    handleCloseDialog();
  };
  return {
    openDialog,
    topicType,
    handleSaveDialog,
    handleCloseDialog,
    handleOpenDialog
  };
};
export const DropdownsContainer = () => {
  const [isSupportingContentChecked, setIsSupportingContentChecked] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchClusters());
  }, [dispatch]);
  const isFetchingClusters = useSelector(selectIsFetchingClusters);
  const hasClusters = useSelector(selectHasClusters);
  const clusterDropdownOptions = useSelector(selectClusterDropdownOptions);
  const canCreateCluster = clusterDropdownOptions.length < MAX_CLUSTERS_LIMIT;
  const selectedClusterId = useSelector(selectSelectedClusterId);
  const showSubtopicDropdown = !!selectedClusterId && isSupportingContentChecked;
  const handleClusterChange = event => {
    const {
      value
    } = event.target;
    dispatch({
      type: SELECTED_CLUSTER_CHANGED,
      payload: {
        selectedClusterId: value
      }
    });
  };
  const handleIsSupportingContentChanged = event => {
    const {
      checked
    } = event.target;
    setIsSupportingContentChecked(checked);
  };
  const {
    openDialog,
    topicType,
    handleSaveDialog,
    handleCloseDialog,
    handleOpenDialog
  } = useCreateTopicDialog({
    selectedClusterId
  });
  if (isFetchingClusters) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "centered",
      minHeight: 200
    });
  }
  return /*#__PURE__*/_jsxs(View, {
    margin: "600",
    as: "div",
    children: [openDialog && /*#__PURE__*/_jsx(CreateTopicDialog, {
      headerText: /*#__PURE__*/_jsx(DialogHeaderText, {
        topicType: topicType
      }),
      messageText: /*#__PURE__*/_jsx(DialogMessageText, {
        topicType: topicType
      }),
      onSave: handleSaveDialog,
      onClose: handleCloseDialog
    }), hasClusters && /*#__PURE__*/_jsxs("section", {
      children: [/*#__PURE__*/_jsx(ClusterDropdown, {
        options: clusterDropdownOptions,
        value: selectedClusterId,
        canCreateCluster: canCreateCluster,
        onOpenCreateTopicDialog: handleOpenDialog,
        onClusterChange: handleClusterChange
      }), selectedClusterId && /*#__PURE__*/_jsx(IsSupportingContentCheckbox, {
        isSupportingContentChecked: isSupportingContentChecked,
        onChange: handleIsSupportingContentChanged
      }), showSubtopicDropdown && /*#__PURE__*/_jsx(SubtopicDropdown, {
        selectedClusterId: selectedClusterId,
        onOpenCreateTopicDialog: handleOpenDialog
      }), /*#__PURE__*/_jsx(AttachButton, {})]
    }), !hasClusters && /*#__PURE__*/_jsx(ZeroState, {
      onOpenCreateTopicDialog: handleOpenDialog
    })]
  });
};